(() => {
  const SCROLL_KEYS = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];
  const INTERACTIVE = 'button, a, input, textarea, select, summary, [tabindex]';

  const initHeader = (section) => {
    const header = section.querySelector('.cs-header');
    if (!header || header.dataset.csInit === '1') return;
    const burger = header.querySelector('.cs-header__burger');
    const overlay = header.querySelector('.cs-menu-overlay');
    const menu = header.querySelector('.cs-menu');
    if (!burger || !overlay || !menu) return;
    header.dataset.csInit = '1';

    const isOpen = () => header.classList.contains('is-menu-open');
    const inertTargets = () => document.querySelectorAll('#MainContent, .shopify-section.section-cs-footer');

    const preventTouchWheel = (event) => {
      if (!menu.contains(event.target)) event.preventDefault();
    };

    const onKeydown = (event) => {
      if (event.key === 'Escape' && isOpen()) {
        setOpen(false);
        burger.focus();
        return;
      }
      if (!SCROLL_KEYS.includes(event.key) || menu.contains(event.target)) return;
      if (event.target instanceof Element && event.target.closest(INTERACTIVE)) return;
      event.preventDefault();
    };

    const setOpen = (open) => {
      header.classList.toggle('is-menu-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('cs-menu-open', open);
      inertTargets().forEach((el) => el.toggleAttribute('inert', open));
      const method = open ? 'addEventListener' : 'removeEventListener';
      document[method]('touchmove', preventTouchWheel, { passive: false });
      document[method]('wheel', preventTouchWheel, { passive: false });
      document[method]('keydown', onKeydown);
    };

    burger.addEventListener('click', () => setOpen(!isOpen()));
    overlay.addEventListener('click', () => setOpen(false));
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });

    const desktop = window.matchMedia('(min-width: 990px)');
    const onDesktopChange = (event) => {
      if (event.matches && isOpen()) setOpen(false);
    };
    desktop.addEventListener('change', onDesktopChange);

    header.csTeardown = () => {
      if (isOpen()) setOpen(false);
      desktop.removeEventListener('change', onDesktopChange);
      delete header.dataset.csInit;
    };
  };

  document.querySelectorAll('.section-cs-header').forEach(initHeader);

  /* Theme editor rendert secties opnieuw zonder page load. */
  document.addEventListener('shopify:section:load', (event) => initHeader(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const header = event.target.querySelector('.cs-header');
    if (header && header.csTeardown) header.csTeardown();
  });
})();
